import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dispatch } from "redux";
import { Action, Case } from "../interfaces/ReducerCase";
import StoreType from "../interfaces/StoreType";

export default function UseCookies(): {
  closeCookies: (adds: boolean, socialNetworks: boolean) => void;
  isSettings: boolean;
  setIsSettings: React.Dispatch<React.SetStateAction<boolean>>;
  isMoreInformations: boolean;
  setIsMoreInformations: React.Dispatch<React.SetStateAction<boolean>>;
  isAdds: boolean;
  setIsAdds: React.Dispatch<React.SetStateAction<boolean>>;
  isSocialNetwork: boolean;
  setIsSocialNetwork: React.Dispatch<React.SetStateAction<boolean>>;
} {
  const { isTCValidated } = useSelector((state: StoreType) => ({
    ...state.RouterReducer,
  }));
  const [isSettings, setIsSettings] = useState<boolean>(
    isTCValidated === null ? true : false
  );
  const [isMoreInformations, setIsMoreInformations] = useState<boolean>(false);
  const [isAdds, setIsAdds] = useState<boolean>(true);
  const [isSocialNetwork, setIsSocialNetwork] = useState<boolean>(true);

  const dispatch: Dispatch<Action> = useDispatch();

  const closeCookies = (adds: boolean, socialNetworks: boolean) => {
    dispatch({
      type: Case.SET_TC,
      payload: { choices: { adds, socialNetworks } },
    });
    localStorage.setItem(
      "isTCValidated",
      JSON.stringify({ adds, socialNetworks })
    );
  };
  return {
    closeCookies,
    isSettings,
    setIsSettings,
    isMoreInformations,
    setIsMoreInformations,
    isAdds,
    setIsAdds,
    isSocialNetwork,
    setIsSocialNetwork,
  };
}
